// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import nexus from '@db2b/nexus-js'
Vue.use(nexus, { axios })

// Setup element ui interface
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI, { locale })

import VueHighcharts from 'vue-highcharts'
Vue.use(VueHighcharts)

nexus.on('disconnected', function () {
  router.push('/')
})

Vue.prototype.$http = nexus.axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js